import { render } from "./MergeHeader.vue?vue&type=template&id=942beb80"
import script from "./MergeHeader.vue?vue&type=script&lang=ts"
export * from "./MergeHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script